import { type Device } from '@pitbrain/shared'
import useApi from '../../../api/useApi'
import ConfigurationContext from '../../../core/providers/ConfigurationContext'
import { useContext } from 'react'
import { GPS_ONLY_FEATURES, useCreateSession } from '../useCreateSession'
import { rawTelemetryFromKmhRows } from '../gpsReadings'
import { type UploadFormat } from '../UploadFormat'

const PZRACING: Device = { name: 'PzRacing', version: '1.0' }

export const usePzRacingProcessor = (): UploadFormat => {
  const bffConfig = useContext(ConfigurationContext)
  const api = useApi(bffConfig)
  const createSession = useCreateSession(api)

  const processFile = async (file: File, sessionId: string): Promise<void> => {
    const results = await api.fileApi.convertSesFile(file)
    const rawTelemetry = rawTelemetryFromKmhRows(results, PZRACING)
    await createSession(rawTelemetry, {
      sessionId,
      fileName: file.name,
      device: PZRACING,
      sessionFeatures: GPS_ONLY_FEATURES,
    })
  }

  return {
    extensions: ['.SES'],
    keepsFileAsSource: true,
    processFile,
    error: api.error,
  }
}
